// import { createStore, applyMiddleware } from 'redux';
// import createSagaMiddleware from 'redux-saga';
// import { logger } from 'redux-logger';
// import storage from 'redux-persist/lib/storage';
// import { persistStore, persistCombineReducers } from 'redux-persist';
// import rootReducerCombine from './reducers';
// import userReducer from './userReducer';
// import rootSaga from './sagas';

// const sagaMiddleware = createSagaMiddleware();

// /* Redux-Persist */

// // const rootReducer = persistCombineReducers({
// //     key: 'root',
// //     storage,
// // }, userReducer);

// /* Create Store */

// export const store = createStore(
//     // userReducer,
//     rootReducerCombine,
//     applyMiddleware(sagaMiddleware, logger)
// );

// // /* Redux-Persist + Store */

// export const persistor = persistStore(store);

// // /* Run saga */

// sagaMiddleware.run(rootSaga);
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { logger } from 'redux-logger';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import rootReducerCombine from './reducers';
// import userReducer from './userReducer';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();

/* Redux-Persist */

// const rootReducer = persistCombineReducers({
//     key: 'root',
//     storage,
// }, userReducer);

const persistConfig = {
    // configuration object for redux-persist
    key: 'root',
    storage, // define which storage to use
};

const persistedReducer = persistReducer(persistConfig, rootReducerCombine);
/* Create Store */

const store = createStore(
    // userReducer,
    persistedReducer,
    applyMiddleware(sagaMiddleware, logger)
);

// /* Redux-Persist + Store */

const persistor = persistStore(store);
export { store, persistor };

// /* Run saga */

sagaMiddleware.run(rootSaga);
